import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandingConfigurationService } from '@ptl/brand';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';

@Injectable({
  providedIn: 'root'
})
export class RenameAppService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService
  ) { }

  renameApplication(applicationTrackingId: string, applicationName: string): Promise<unknown> {
    const payload = {
      applicationTrackingId,
      applicationName
    };

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/sxesvc/api/v3/ext/user/renameApp',
      POST_OR_PUT_PAYLOAD: payload,
      contentType: 'force_undefined',
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded(),
      }),
      strategyConfigs: { forceModernUrl: true }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }
}
